import type {Timestamp}                              from 'firebase-admin/firestore';
import {GlobalRecordBaseIntf, GlobalRecordGroupType} from '../global/global.types';

export interface HeartRateNotificationsIntf {
	"data": {
		heartRateNotifications: HeartRateNotificationIntf[]
	}
}

export type HkitPathListIntf = {
	[key in GlobalRecordGroupType]: (key extends 'log' ? HkitRecordLogType : HkitRecordSumType)[]
}

export type HkitPayloadIntf = {
	[key in GlobalRecordGroupType]: key extends 'log' ? HkitCollection<HkitRecordLogType> : HkitCollection<HkitRecordSumType>
}
export type HkitCollection<T extends HkitRecordLogType | HkitRecordSumType> = {
	[key in T]: HkitRecordLogIntf[]
}


export interface HeartRateNotificationIntf {
	"start": Date,
	"heartNotification": string,
	"end": Date,
	"source": HeartAlertSourceIntf,
	"threshhold": number,
	"hrvData": HeartAlertHrvIntf[],
	"heartRateData": HeartAlertDataIntf[],
	"id": string
}


export interface HkitRecordLogIntf extends GlobalRecordBaseIntf {
	unit: string;
	qty: number;
	type: HkitRecordUnionType;
}


export type HkitRecordLogType =
// | 'apple_stand_hour'
	| 'blood_oxygen_saturation'
	| 'environmental_audio_exposure'
	| 'handwashing'
	| 'headphone_audio_exposure'
	| 'respiratory_rate'
	| 'toothbrushing'
	| 'weight_body_mass'
	| 'dietary_water'

export const HkitRecordLogTypes: HkitRecordLogType[] = [
	'blood_oxygen_saturation',
	'environmental_audio_exposure',
	'handwashing',
	'headphone_audio_exposure',
	'respiratory_rate',
	'toothbrushing',
	'weight_body_mass',
	'dietary_water'
]


export type HkitRecordSumType =
	| 'active_energy'
	| 'apple_exercise_time'
	| 'apple_stand_time'
	// | 'apple_move_time'
	| 'step_count'
	| 'basal_energy_burned'
	| 'time_in_daylight'
	| 'dietary_water'

export const HkitRecordSumTypes: HkitRecordSumType[] = [
	'active_energy',
	'apple_exercise_time',
	'apple_stand_time',
	// 'apple_move_time',
	'step_count',
	'basal_energy_burned',
	'time_in_daylight',
	'dietary_water'
]

export type HkitMasterType = 'hkit'

export type HkitRecordOddType =
	| 'heart_alert'
	| 'workout'

export const HkitRecordOddTypes: HkitRecordOddType[] = [
	'heart_alert',
	'workout'
]

export type HkitRecordUnionType =
	| HkitRecordLogType
	| HkitRecordSumType


export interface HkitUnitIntf {
	'qty': number,
	'units': string
}


//Heart

export interface HkitHeartAlertsIntf {
	'start': Timestamp,
	'heartNotification': string,
	'end': Timestamp,
	'endString'?: string,
	'source': HeartAlertSourceIntf,
	'threshhold': number,
	'hrvData': HeartAlertHrvIntf[],
	'heartRateData': HeartAlertDataIntf[],
	'id': string
}

export interface HeartAlertSourceIntf {
	'name': string;
	'identifier': string;
}

export interface HeartAlertDataIntf {
	'timestamp': HeartAlertTimeIntf
	'heartRate': number,
	'hrUnits': string,
}

export interface HeartAlertHrvIntf {
	'timestamp': HeartAlertTimeIntf,
	'hrv': number,
	'units': string
}

export interface HeartAlertTimeIntf {
	'measurementDuration': number
	'units': string,
	'start': string
	'end': string
}

//Workout
export interface HkitPointIntf {
	'units': string
	'date': string
	'qty': number,
	'source': string
}

export interface HkitPointHeartIntf extends Omit<HkitPointIntf, 'qty'> {
	'Min': number;
	'Avg': number;
	'Max': number;
}


export interface HkitExportWorkoutIntf {
	"data": {
		workouts: HkitWorkoutIntf[]
	}
}


export interface HkitWorkoutIntf {
	'location': string;
	'id': string,
	'name': string,
	'start': Timestamp,
	'end': Timestamp,
	'endString'?: string,
	'heartRateData': HkitPointHeartIntf[],
	'heartRateRecovery': HkitPointHeartIntf[],
	'duration': number,
	'route': {
		'speed': number;
		'speedAccuracy': number;
		'course': number;
		'latitude': number;
		'horizontalAccuracy': number;
		'longitude': number;
		'altitude': number;
		'courseAccuracy': number;
		'verticalAccuracy': number;
		'timestamp': Timestamp;
	}[],
	'totalEnergy': HkitUnitIntf,
	'activeEnergy': HkitPointIntf[],
	'walkingAndRunningDistance': HkitPointIntf[]
	'maxHeartRate': HkitUnitIntf,
	'avgHeartRate': HkitUnitIntf,
	'stepCount': HkitPointIntf[],
	'stepCadence': HkitUnitIntf,
	'totalSwimmingStrokeCount': HkitUnitIntf,
	'swimCadence': HkitUnitIntf,
	'distance': HkitUnitIntf,
	'speed': HkitUnitIntf,
	'flightsClimbed': HkitUnitIntf,
	'intensity': HkitUnitIntf,
	'temperature': HkitUnitIntf,
	'humidity': HkitUnitIntf,
	'elevation': {
		'ascent': number,
		'descent': number,
		'units': string
	},
	'metadata': any,
	'activeEnergyBurned': HkitUnitIntf,
	'elevationUp': HkitUnitIntf


}

export type HkitRecordGroupSubDict<T extends HkitRecordLogType | HkitRecordSumType, D> = {
	[key in T]: D
}

export type HkitRecordGroupDict<LOG, SUM> = {
	[key in GlobalRecordGroupType]: key extends 'log' ? LOG : SUM
}